<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>跟读记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="学生ID：">
              <Input v-model="queryParam.studentId" placeholder="学生ID" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="姓名：">
              <Input v-model="queryParam.username" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="手机号：">
              <Input v-model="queryParam.mobile" placeholder="手机号" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="类型：">
              <Select v-model="queryParam.evalType" placeholder="全部" clearable>
                <Option value="WORD">单词</Option>
                <Option value="SENTENCE">句子</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="文本：">
              <Input v-model="queryParam.content" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/studentWordcardEval/list"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        studentId: '',
        username: '',
        mobile: '',
        evalType: '',
        content: ''
      },
      title: [
        {title: '学生ID', width: 100, key: 'studentId'},
        {title: '姓名', minWidth: 100, key: 'username'},
        {
          title: '手机号',
          width: 130,
          render: (h, params) => this.renderMobile(h, params.row.mobile)
        },
        {
          title: '类型',
          width: 90,
          render: (h, params) => {
            let t = params.row.evalType
            if (t === 'WORD') {
              return h('span', '单词')
            }
            if (t === 'SENTENCE') {
              return h('span', '句子')
            }
            return h('span', t || '')
          }
        },
        {title: '文本', minWidth: 180, key: 'content'},
        {title: '得分', width: 80, key: 'score'},
        {title: '反馈', minWidth: 160, key: 'feedback'},
        {
          title: '录音',
          minWidth: 200,
          render: (h, params) => {
            let url = params.row.audioUrl
            if (!url) {
              return h('span', '')
            }
            return h('audio', {
              attrs: {src: url, controls: 'controls', preload: 'none'},
              style: {width: '180px', height: '32px'}
            })
          }
        },
        {title: '时间', minWidth: 160, key: 'gmtCreate'}
      ]
    }
  },
  methods: {
    renderMobile (h, mobile) {
      if (!mobile || (typeof mobile === 'string' && mobile.startsWith('n'))) {
        return h('span', '')
      }
      let display = String(mobile).length === 11
        ? String(mobile).substring(0, 3) + '****' + String(mobile).substring(7)
        : mobile
      return h('Poptip', {
        props: {trigger: 'hover'}
      }, [
        h('span', {}, display),
        h('div', {slot: 'content'}, mobile)
      ])
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentWordcardEvalList.vue?0bd790df